document.addEventListener("DOMContentLoaded", function () {
  const controls = document.getElementsByClassName('js-hero-carousel--control');
  if (controls) {
    for (let i = 0; i < controls.length; i++) {
      const control = controls[i];
      control.addEventListener('click', function (e) {
        activateHero(e.target.dataset.index);
      });
    }
    const container = document.querySelector('.js-hero-carousel--container');
    if (container) {
      const timeout = Number(container.dataset.timeout) * 1000;
      if (timeout && timeout > 0) {
        setTimeout(() => autoToggle(timeout), timeout);
      }
    }
    const next = document.querySelector('.js-hero-carousel--next');
    if (next) {
      next.addEventListener('click', function (e) {
        toggle(true);
      });
    }
    const previous = document.querySelector('.js-hero-carousel--previous');
    if (previous) {
      previous.addEventListener('click', function (e) {
        toggle(false);
      });
    }
  }
});

function activateHero(index) {
  const heroes = document.getElementsByClassName('js-hero-carousel--hero');
  const controls = document.getElementsByClassName('js-hero-carousel--control');
  const heroActiveClass = 'c-hero--slide-active';
  const controlActiveClass = 'c-carousel__control-item-active';
  if (heroes && controls && heroes.length == controls.length) {
    for (let i = 0; i < heroes.length; i++) {
      const hero = heroes[i]
      const control = controls[i];
      if (i == index) {
        hero.classList.add(heroActiveClass);
        control.classList.add(controlActiveClass);
      }
      else {
        hero.classList.remove(heroActiveClass);
        control.classList.remove(controlActiveClass);
      }
    }
  }
}

function toggle(forward) {
  const controls = document.getElementsByClassName('js-hero-carousel--control');
  const controlActiveClass = 'c-carousel__control-item-active';
  if (controls) {
    const activeControl = Array.from(controls).filter(x => x.classList.contains(controlActiveClass));
    if (activeControl && activeControl.length > 0) {
      const activeHeroIndex = Number(activeControl[0].dataset.index);
      if (forward) {
        let nextHeroIndex = activeHeroIndex + 1;
        if (nextHeroIndex >= controls.length) {
          nextHeroIndex = 0;
        }
        activateHero(nextHeroIndex);
      } else {
        let previousHeroIndex = activeHeroIndex - 1;
        if (previousHeroIndex < 0) {
          previousHeroIndex = controls.length - 1;
        }
        activateHero(previousHeroIndex);
      }
    }
  }
}

function autoToggle(timeout) {
  toggle(true);
  setTimeout(() => autoToggle(timeout), timeout);
}